/*eslint-disable */

import PDFUploader from '@/components/pdfViewer/PDFUploader.vue'
import PDFViewer from '@/components/pdfViewer/PDFViewer.vue'
import axios from 'axios';
import {
  bus
} from '@/main';
import pdfAnnotate from './pdf-render-annotation/'
import pdfNotes from './pdf-notes/'
import root from '@/_helpers/roots';
import toast from '@/services/toast';

let saveAnnotationApiUrl = root.saveAnnotationApiUrl.link;

var $ = window.jQuery = require('jquery');
export default {
  name: 'pdf-viewer',
  components: {
    PDFUploader,
    PDFViewer,
    pdfNotes,
    pdfAnnotate
  },
  props: [
    'pdfViewerURL',
    'pdfViewerFileNAME',
    'pdfID'
  ],
  data () {
    return {
      url:'',
      documentError: undefined,
      enableUploader: process.env.VUE_APP_UPLOAD_ENABLED === 'true',
      PdfNotesState:false,
      PdfNotesStateClass:false,
      isSubmitted:false
    }
  },
  computed: {

  },
  mounted () {
    this.url = this.pdfViewerURL
    this.resizeEnabledMethod()
  },
  methods: {    
    appliedChangesMethod(){
      // To get annotations:
      let annotations = localStorage.getItem(`${this.url}/annotations`);
      // if(!annotations) return;
      this.isSubmitted = true
      const requestBody = {
        paper_id: this.pdfID,
        annotation_data:annotations,
      }
      axios.post(saveAnnotationApiUrl, requestBody).then((res) => {
        toast.success("Request processed successfully.");
        this.isSubmitted = false
        this.pdfViewerCloseFun();
      }).catch((err) => {
        this.isSubmitted = false
        toast.error('Request Failed');
      })
    },
    resizeEnabledMethod(){
      var isResizing = false,
      lastDownX = 0;
      var left = $('#left_panel'),
          handle = $('#drag');
        handle.on('mousedown', function (e) {
            isResizing = true;
            lastDownX = e.clientX;
        });
        $(document).on('mousemove', function (e) {
            // we don't want to do anything if we aren't resizing.
            if (!isResizing) return;
            let screenDistance = e.view.outerWidth - e.clientX
            if(e.clientX > 290 && screenDistance > 750){
              left.css('width', e.clientX);
            }
        }).on('mouseup', function (e) {
            // stop resizing
            isResizing = false;
        });
    },
    getPaperListAgain(){
      if(this.$route.params.bucketId != undefined){
        this.$store.dispatch('getBucketDetailsByIdOfAwerackFun', { id:this.$route.params.bucketId})
      }else{
        this.$store.dispatch('getAllPaperPileFun')
      }
    },
    openNoteSectionMethod(){
      $('.toolbar .cursor').click();
      if(this.PdfNotesState == true){
       this.PdfNotesState = false
       setTimeout(() => {
         this.PdfNotesStateClass = false
       }, 10)
      }else{
        this.PdfNotesState = true
        $('#left_panel').css('width', '290px');
        setTimeout(() => {
          this.PdfNotesStateClass = true
        }, 10)
      }
    },
    urlUpdated(url) {
      this.documentError = undefined;
    },
    onDocumentErrored(e) {
      this.documentError = e.text;
    },
    pdfViewerCloseFun(){
      $('.toolbar .cursor').click();
      this. getPaperListAgain()
      bus.$emit('pdfViewerPopupBus', false);
      $('body').removeClass("overflow-hidden")
      $('body').removeClass("pdf_view_actv")
    },
  }
}


